<template>
  <div class="brandPublicity page">
    <v-header :headTitle="headTitle" :isBack="false" v-if="false"></v-header>
    <!-- <v-header
      :headTitle='headTitle'
      :isBack='true'
      v-if="isNavShow"
    ></v-header> -->
    <div class="container">
      <div class="container_head">
        <div class="df-between">
          <img
            src="../../assets/images/detail/story/iv_logo.png"
            class="image"
          />
          <div @click="jumpTo('/catalogue')">
            <img
              id="catalogue"
              src="../../assets/images/home/i-catalogue.png"
              class="catalogue"
              v-if="true"
            />
          </div>
        </div>
        <div class="link_title">
          <p class="link_style first" >也许</p>
          <p class="link_style first first_title">{{ title }}</p>
          <p class="link_style two">{{ content1 }}</p>
          <p class="link_style three">{{ content2 }}</p>
          <div class="tob meeting">
            <img
              src="../../assets/images/detail/story/arrows_left.png"
              class="img_left arrows"
            />
            <span class="overstriking">初遇</span>
            <img
              src="../../assets/images/detail/story/arrows_right.png"
              class="img_right arrows"
            />
          </div>
          <p class="p_bold tob">我们为感控而生</p>
        </div>
      </div>
      <p
        class="p_content"
        v-for="(item, index) in meetingList"
        :key="item.id + '-meeting'"
      >
        {{ item.content }}
      </p>
      <div class="contentTob">
        <img
          src="../../assets/images/detail/story/arrows_left.png"
          class="img_left arrows"
        />
        <span class="overstriking">初心</span>
        <img
          src="../../assets/images/detail/story/arrows_right.png"
          class="img_right arrows"
        />
      </div>
      <p class="p_bold">我们能做什么</p>
      <p
        class="p_content"
        v-for="(item, index) in originalList"
        :key="item.id + '-original'"
      >
        {{ item.content }}
      </p>
      <div class="contentTob">
        <img
          src="../../assets/images/detail/story/arrows_left.png"
          class="img_left arrows"
        />
        <span class="overstriking">成长</span>
        <img
          src="../../assets/images/detail/story/arrows_right.png"
          class="img_right arrows"
        />
      </div>
      <p class="p_bold">我们做了什么</p>
      <p class="p_text_bg">搭建知识库，提供个人高效成长通道</p>
      <p
        class="p_content"
        v-for="(item, index) in growList"
        :key="item.id + 'grow'"
      >
        {{ item.content }}
      </p>
      <div class="distance">
        <p
          class="p_content"
          v-for="(item, index) in growList2"
          :key="item.id + '-grow2'"
        >
          {{ item.content }}
        </p>
      </div>
      <p class="p_text_bg distance">构建评价模型，实现“查-学-改”过程量化管理</p>
      <p
        class="p_content"
        v-for="(item, index) in patternList"
        :key="item.id + '-pattern'"
      >
        {{ item.content }}
      </p>
      <p class="p_content distance">
        达到院内感染防控实时可查，可看，可响应，可追溯，可监测
      </p>
      <p class="p_text_bg distance">组建核心团队，实现对结果负责的服务文化</p>
      <div
        class="time"
        v-for="(item, index) in timeList"
        :key="item.id + '-time'"
      >
        <div class="df-center w-100">
          <!-- <img class="list_img" :src="item.imgUrl" /> -->
          <span class="time_title">{{ item.title }}</span>
        </div>
        <p v-html="item.content"></p>
      </div>
      <p class="summarize">
        可以<span>节约</span>院科两级在督查记录、统计以及报告、院科协同改善、人员培训等环节近<span>50%</span>的时间，从而让专职人员可以更专注督查和指导，减少<span>临床</span>科室每月在这些环节近<span>2-3个工作日</span>的投入。
      </p>

      <div class="contentTob">
        <img
          src="../../assets/images/detail/story/arrows_left.png"
          class="img_left arrows"
        />
        <span class="overstriking">收获</span>
        <img
          src="../../assets/images/detail/story/arrows_right.png"
          class="img_right arrows"
        />
      </div>
      <p class="p_bold">我们改变了什么</p>

      <div class="solution_body">
        <div class="left">
          <div class="left_title df-center">
            <span>管理现状</span>
            <img
              src="../../assets/images/detail/monitorReport/i-cry.png"
              alt=""
              style="width: 16px; height: 16px"
            />
          </div>
          <div class="text_item">认为感控是院感专职人员的事</div>
          <div class="text_item">手工进行数据处理是最累人的工作模式</div>
          <div class="text_item">左右得罪人的“管理部门”</div>
          <div class="text_item">遇到检查就突击补资料，手忙脚乱</div>
        </div>
        <div class="vs">
          <img
            src="../../assets/images/detail/monitorReport/i-vs.png"
            alt=""
            style="width: 44px; height: 44px"
          />
        </div>
        <div class="right">
          <div class="right_title df-center">
            <span>使用工作间后</span>
            <img
              src="../../assets/images/detail/monitorReport/i-smile.png"
              alt=""
              style="width: 16px; height: 16px"
            />
          </div>
          <div class="text_item">感控是大家的事</div>
          <div class="text_item">轻松上阵、科学感控</div>
          <div class="text_item">赋能全员，快速协同</div>
          <div class="text_item">有条不紊，随时迎检</div>
        </div>
      </div>

      <div class="contentTob">
        <img
          src="../../assets/images/detail/story/arrows_left.png"
          class="img_left arrows"
        />
        <span class="overstriking">希望</span>
        <img
          src="../../assets/images/detail/story/arrows_right.png"
          class="img_right arrows"
        />
      </div>
      <p class="p_bold">我们将去往何方</p>
      <div class="hope">
        <p
          class="p_content"
          v-for="(item, index) in futureList"
          :key="item.id + '-future'"
        >
          {{ item.content }}
        </p>
        <div class="foot-category">
          <div class="foot-category-inner">
            <h3 class="about_title about_title_1">联系我们</h3>
            <ul>
              <li
                class="about_desc"
                v-for="(item, index) in contactList"
                :key="item.id + '-contact'"
              >
                <span class="contact about_desc">{{ item.contact }}</span>
                <span class="moblie about_desc" @click="callPhone(item.phone)">{{
                  item.phone
                }}</span>
              </li>
            </ul>
            <div style="height: 40px; width: 100%"></div>
            <template v-if="true">
              <h3 style="margin: 0" class="about_title">关于我们</h3>
              <div class="my_seft" style="padding-bottom: 0">
                <span class="contact moblie about_desc" @click="goUp">我们的故事</span>
                <span class="contact moblie about_desc" @click="jumpTo('/serviceList')"
                  >服务清单及报价</span
                >
              </div>
              <div class="my_seft" style="padding-top: 0">
                <span
                  class="contact moblie about_desc"
                  @click="jumpTo('/brandPublicity?type=hospital')"
                  >院内感控</span
                >
                <span
                  class="contact moblie about_desc"
                  @click="jumpTo('/brandPublicity?type=area')"
                  >区域感控</span
                >
              </div>
              
              <!-- <div class="product">
            <span>产品服务介绍</span>
            <span class="iconfont icon-jiantouxia"></span>
          </div> -->
            </template>
          </div>
        </div>

        <img
          v-if="false"
          class="bottom"
          src="../../assets/images/detail/story/bottom_bg.png"
        />
      </div>
    </div>
    <!--    <a href="#banner" v-if="false">-->
    <div class="v-top df-center df-column" @click="goUp" v-show="isBackTopShow">
      <img src="../../assets/images/home/i-top.png" alt="" />
      顶部
    </div>
  </div>
</template>

<script>
import header from "../../components/header/header";
import footer from "../../components/footer/footer";
import BetterScroll from "better-scroll";
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { Button, Tab, Tabs, Swipe, SwipeItem, ImagePreview, Popup } from "vant";
import axios from "axios";
Vue.use(Button);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
export default {
  name: "myStory",
  data() {
    return {
      headTitle: "我们的故事",
      // 导航栏显示
      isNavShow: true,
      // 返回顶部显示
      isBackTopShow: false,
      title: "你是感控工作间的“常旅客”",
      content1: "也许，你是今天刚来感控工作间报到的新人",
      content2:
        "不管是怎样的，\n过去，现在，未来\n您们都是感控工作间历程的见证者\n感谢！一直为医院感染防控努力的您",
      meetingList: [
        {
          id: 1,
          content: "2013年WHO估算，因医院感染给医院增加的医疗费用达 150 亿/年",
        },
        {
          id: 2,
          content: "患者和医务人员的医院感染风险和防控管理问题日渐凸显",
        },
        { id: 3, content: "缺乏先进管理工具是目前医院感染防控的现状" },
      ],
      originalList: [
        {
          id: 1,
          content:
            "医疗服务需求极增，对质量和安全的要求越来越高 专业分科、医院分级，既要标准化也要个性化管理 定制系统需要太长的时间来研发部署，太多的服务来维护和改进",
        },
        {
          id: 2,
          content:
            "我们相信移动工作方式是医疗从业者最需要的，他们比一般群体更需要高效、高质量的工作和学习工具与服务，移动工具连接人和组织，借助技术帮助专业用户将知识和数据赋能更多人，改变现有工作状况",
        },
        {
          id: 3,
          content:
            "所以在2015年，我们推出了更快部署、更低成本享受更多改进的服务模式，才能真正满足这个特殊的行业和日益增长且变化的需求",
        },
      ],
      growList: [
        { id: 1, content: "我们收集并整理工作资料" },
        { id: 2, content: "在这里，找到您工作的所需" },
        { id: 3, content: "形成您的知识体系" },
        { id: 4, content: "扫除您的职业盲点" },
        { id: 5, content: "收藏您的兴趣文献" },
        { id: 6, content: "您需要的，怎么也下不完，过瘾！" },
      ],
      growList2: [
        { id: 1, content: "我们邀请专家讲课并鼓励感控有志青年投稿交流" },
        { id: 2, content: "在这里，不仅可以定期获得专家授课视频" },
        { id: 3, content: "形成您的知识体系" },
        { id: 4, content: "进一步提升您的专业知识" },
        { id: 5, content: "我们也热烈欢迎您能够加入我们进行内容创作" },
        { id: 6, content: "为全社会感控事业贡献自己的一份力量！" },
      ],
      futureList: [
        {
          id: 1,
          content:
            "为协助24000家医疗机构低成本实现医疗安全与质量管理效能不断提升而努力！",
        },
        {
          id: 2,
          content:
            "让每个医疗机构更方便有效地预防与控制医院感染 让每位医务人员更好的防控医院感染",
        },
      ],
      contactList: [
        { id: 1, contact: "招商合作：", phone: "180-7513-6295" },
        { id: 2, contact: "体验/购买：", phone: "173-5285-9232" },
        { id: 3, contact: "购买后使用：", phone: "189-7584-0173" },
      ],
      patternList: [
        { id: 1, content: "查：查检评价在线，实现查检/评价效率提升" },
        { id: 2, content: "学：培训考核在线，实现全员能力提升" },
        {
          id: 3,
          content: " 改：改进协同在线及管理经验知识共享，管理改善效果提升",
        },
        // { id: 4, content: "我们也热烈欢迎您能够加入我们进行内容创作" },
        // { id: 5, content: "为全社会感控事业贡献自己的一份力量！" },
      ],
      timeList: [
        {
          id: 1,
          title: "资深业务专家",
          content:
            "聘请质量管理、风险控制、医院业务管理与评价领域的资深业务专家，提供知识服务等专家支持。",
          // imgUrl: require("../../assets/images/detail/story/specialist.png"),
        },
        {
          id: 2,
          title: "客户成功团队",
          content:
            "一对一服务客户</br>从购买前到购买后都有全程服务和跟进</br>专注购买后的服务，帮助客户使用成功而不是产品的销售",
          // imgUrl: require("../../assets/images/detail/story/custom.png"),
        },
        {
          id: 3,
          title: "互联网开发及运营的业界精英",
          content:
            "共同致力于提升质量与安全管理效能，让您轻松完成全员全过程全面质量改进的便捷管控与增质提效。",
          // imgUrl: require("../../assets/images/detail/story/internet.png"),
        },
      ],
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  mounted() {
    this.cnzzStat('公司介绍', '打开我们的故事','我们的故事(Key_Company_Indroduction)');
    this.isHideNavBar();
    // 窗口滚动事件
    window.addEventListener("scroll", this.handleScroll);
    this.goDefaultTop();
    setTimeout(() => {
        this.initIndexShare()
      }, 500);
  },
  created() {
    setTimeout(() => {
        this.initIndexShare()
      }, 500);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 是否隐藏导航栏
    isHideNavBar() {
      let ua = navigator.userAgent.toLowerCase();
      let isWX = ua.match(/MicroMessenger/i) == "micromessenger";
      console.log(isWX);
      this.isNavShow = !isWX;
    },
    jumpTo(path) {
      // console.log('1111');
      this.$router.push(path);
    },
    // 返回顶部
    goUp() {
      // console.log('返回顶部....')
      let nowTop =
        document.body.scrollTop || document.documentElement.scrollTop; // 获取当前滚动条位置
      // console.log(nowTop);
      if (nowTop > 0) {
        window.requestAnimationFrame(this.goUp);
        window.scrollTo(0, nowTop - nowTop / 5);
      }
    },
  },
};
</script>
  <style lang='scss' scoped>
.brandPublicity {
  .container {
    height: 100%;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
    .container_head {
      box-sizing: border-box;
      height: 488px + 103px;
      background-image: url('../../assets/images/bg-banner111.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      /*-moz-background-size:100% 100%;*/
      padding-top: 10px;
      padding-right: 15px;
      :first-child {
        box-sizing: border-box;
        // padding: 5px 0 0 0 ;
        .image {
          // float: left;
          flex-shrink: 0;
          width: 131px;
          height: 50px;
        }
        .catalogue {
          // float: right;
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          img {
            flex-shrink: 0;
            width: 24px;
            height: 24px;
          }
          // margin-top: 10px;
        }
      }
      .link_title {
        clear: both;
        padding-top: 49px;
        margin-left: 15px;
        text-align: center;
        /* line-height: 32px; */
        .link_style {
          white-space: pre;
          // color: #025bad;
          color: #0F83EF;
        }
        .first {
          font-size: 22px;
          font-weight: 900;
          margin-bottom: 5px;
          // line-height: 42px;
          font-family: SourceHanSansCN, SourceHanSansCN-Heavy;
        }
        .first_title {
          margin-bottom: 10px;
        }
        // .first:last-child {
        //    margin-bottom: 16px;
        // }
        .two {
          font-size: 17px;
          font-weight: 600;
          font-family: PingFangSC, PingFangSC-Medium;
          margin-top: 5px;
          line-height: 24px;
        }
        .three {
          font-size: 16px;
          font-weight: 500;
          font-family: PingFangSC, PingFangSC-Regular;
          margin-top: 20px;
          line-height: 22px;
        }
      }
    }
    .hope {
      background-image: url(../../assets/images/detail/story/hope_bg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      h3 {
        font-size: 13px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: center;
        margin: 70px 20px 0px 20px;
        color: #333333;
        line-height: 18px;
      }
      ul {
        list-style: none;
        padding: 0px;
        margin: 0px;
        text-align: center;
      }
      li {
        margin: 15px 20px 0px 20px;
      }
      .my_seft {
        display: flex;
        padding: 16px 20px 11px 20px;
        text-align: center;
        span {
          flex: 1;
          text-align: center;
        }
      }
      .bottom {
        width: 100%;
        height: 225px;
      }
      .product {
        padding-bottom: 31px;
        text-align: center;
        margin-left: 20px;
      }
      .contact {
        font-size: 13px;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 18px;
        margin-top: 15px;
      }
      .moblie {
        font-size: 13px;
        font-weight: 400;
        text-align: left;
        color: #1c91ff;
        margin-top: 15px;
        margin-left: 15px;
        line-height: 18px;
      }
    }
    .p_text_bg {
      /* background: #ffffff; */
      background: #f5f9ff;
      /* border: 1px solid #dddddd; */
      border-radius: 6px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 700;
      padding: 10px;
      margin: 0px 20px 30px 20px;
    }
    .p_content {
      font-size: 15px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #333333;
      line-height: 24px;
      font-size: 15px;
      text-align: center;
      margin: 0px 20px 10px 20px;
      line-height: 24px;
    }
    .overstriking {
      font-size: 28px;
      font-weight: 600;
      color: #333333;
      line-height: 40px;
    }
    .solution_body {
      margin-top: 22px;
      position: relative;
      height: 294px + 13;
      box-sizing: border-box;
      //padding: 12px;
      //background-color: pink;
      .left {
        position: absolute;
        left: 12px;
        top: 0;
        width: 197px;
        height: 294px;
        background: url("../../assets/images/detail/monitorReport/bg-solution-1.png");
        background-size: 100% 100%;
        .left_title {
          margin-top: 26px;
          margin-left: 9px;
          margin-bottom: 19px;
          width: 131px;
          height: 24px;
          opacity: 1;
          background: #666666;
          border-radius: 12px;
          span {
            margin-top: -1px;
            font-size: 15px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
            color: #ffffff;
            margin-right: 5px;
          }
        }
        .text_item {
          margin-bottom: 15px;
          box-sizing: border-box;
          padding-left: 10px;
          width: 150px;
          height: 40px;
          text-align: center;
          color: #333333;
          line-height: 20px;
        }
      }
      .vs {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
        width: 44px;
        height: 44px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        position: absolute;
        right: 12px;
        bottom: 0;
        width: 197px;
        height: 294px;
        background: url("../../assets/images/detail/monitorReport/bg-solution-2.png");
        background-size: 100% 100%;
        .right_title {
          margin: 13px 10px 19px 57px;
          width: 131px;
          height: 24px;
          opacity: 1;
          background: #ffffff;
          border-radius: 12px;
          span {
            margin: -1px 5px 0 0;
            font-size: 15px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
            color: #1c91ff;
          }
        }
        .text_item {
          margin-left: 44px;
          margin-bottom: 15px;
          width: 144px;
          height: 40px;
          text-align: right;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
    .arrows {
      display: inline;
      width: 40px;
      height: 13px;
    }
    .time {
      text-align: center;
      margin: 32px 20px 0px 20px;
    }
    .time p {
      font-size: 15px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 24px;
      margin-top: 10px;
    }
    .time_title {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: 600;
      text-align: center;
      margin-left: 10px;
      color: #333333;
      line-height: 24px;
    }
    .summarize {
      font-size: 15px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      margin: 10px 20px;
      text-align: center;
      color: #333333;
      line-height: 24px;
    }
    .summarize span {
      color: #1c91ff;
    }
    .p_bold {
      font-size: 20px;
      font-weight: 600;
      color: #6fbefd;
      margin-bottom: 20px;
      line-height: 40px;
      margin-top: 10px;
    }
    .img_left {
      margin-right: 19px;
    }
    .overstriking {
      color: #6fbefd;
    }
    .img_right {
      margin-left: 19px;
    }
    .tob {
      text-align: center;
    }
    .meeting {
      margin-top: 169px;
    }
    .contentTob {
      margin-top: 50px;
    }
    .distance {
      margin-top: 30px;
    }
    .list_img {
      display: inline;
      width: 20px;
      height: 20px;
    }
  }
  .w-100 {
    width: 100% !important;
  }
  .foot-category {
    background: url("../../assets/images/i-story-bg6.png");
    background-size: 100% 100%;
    padding-bottom: 100px;
    .foot-category-inner {
      transform: translateY(40px);
    }
  }
  .about_title {
    font-size: 18px !important;
  }
  .about_desc {
    font-size: 16px !important;
  }
  .about_title_1 {
    margin-bottom: 30px  !important;
  }
}
</style>
